<template>
  <a href="#" class="like-btn" :title="likeTitle" @click.prevent="addToLikes">
    <img src="@/assets/images/liked.png" v-if="inLikes" />
    <img src="@/assets/images/noLike.png" v-else />
  </a>
</template>

<script>
export default {
  name: `StarVideo`,
  props: {
    video: Object,
  },

  methods: {
    addToLikes() {
      this.$store.dispatch(`addToLikes`, this.video);
    },
  },

  computed: {
    inLikes() {
      const list = this.$store.state.user.myVideos.filter(obj => {
        if (`${obj}` === `${this.video.id}`) {
          return true;
        }
        return false;
      });
      if (list.length > 0) {
        return true;
      }
      return false;
    },
    likeTitle() {
      if (this.inLikes) {
        return `הסר מהשיעורים שלי`;
      }
      return `הוסף לשיעורים שלי`;
    },
  },
};
</script>

